// BHP-1062: WordPress VPS detail. Same body as the generic one, plus the
// installation state that the WordPress provisioning writes as a Hetzner label.
import { useParams } from 'react-router-dom';
import VpsServerDetail from '../../features/vps/ui/VpsServerDetail';
import InstallationState from '../../features/vps/ui/InstallationState';

export default function WordpressDetails(): JSX.Element {
  const { uuid } = useParams<{ uuid: string }>();

  return (
    <VpsServerDetail
      uuid={uuid ?? ''}
      overviewPath="/vps/wordpress/overview"
      overviewLabel="Back to WordPress servers"
      extra={(vps) => <InstallationState labels={vps.labels} />}
    />
  );
}
